// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3yZhv","main-image":"Header_main-image__jPFnn"};